import { Dropdown } from "../../common/components/dropdownSelect";
import React from "react";
import { formGroup } from "../../common/components/formGroup";
import { SorgenteClimaType } from "../../generated";
const DropdownList = Dropdown<SorgenteClimaType>();

export const SorgenteClimaTypes = [
    SorgenteClimaType.Acqua,
    SorgenteClimaType.Aria,
    SorgenteClimaType.Geotermico
];

export function GetSorgenteClimaTypeDescription(type: SorgenteClimaType) {
    switch (type) {
        case SorgenteClimaType.Acqua:
            return "Acqua";
        case SorgenteClimaType.Aria:
            return "Aria";
        case SorgenteClimaType.Geotermico:
            return "Geotermico";
        default:
            return "";
    }
}

interface Props {
    value: SorgenteClimaType | null,
    onChange: (type: SorgenteClimaType | null) => void
    error?: string;
    label?: string;
    onBlur?: React.FocusEventHandler;
    onFocus?: React.FocusEventHandler;
}
class __SorgenteClimaTypeSelector extends React.PureComponent<Props> {

    render() {
        const { onChange, value, error, label, onBlur, onFocus } = this.props;
        return <DropdownList
            label={label ?? "Nome configurazione"}
            allowNull
            data={SorgenteClimaTypes}
            textField={x => GetSorgenteClimaTypeDescription(x)}
            onSelect={onChange}
            value={value}
            error={error}
            onBlur={onBlur}
            onFocus={onFocus}
        />;
    }
}
export const SorgenteClimaTypeSelector = formGroup(__SorgenteClimaTypeSelector)

